import { useTranslation } from 'react-i18next';
import { Devices } from '../../participantEnums';

export const useDevices = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: Devices.ANDROID_SMART_PHONE,
      label: t('participants.enums.devices.ANDROID_SMART_PHONE'),
    },
    {
      value: Devices.IOS_SMART_PHONE,
      label: t('participants.enums.devices.IOS_SMART_PHONE'),
    },
    {
      value: Devices.ANDROID_TABLET,
      label: t('participants.enums.devices.ANDROID_TABLET'),
    },
    {
      value: Devices.IOS_TABLET,
      label: t('participants.enums.devices.IOS_TABLET'),
    },
    {
      value: Devices.ANDROID_SMART_WATCH,
      label: t('participants.enums.devices.ANDROID_SMART_WATCH'),
    },
    {
      value: Devices.IOS_SMART_WATCH,
      label: t('participants.enums.devices.IOS_SMART_WATCH'),
    },
    {
      value: Devices.MAC_OS_COMPUTER,
      label: t('participants.enums.devices.MAC_OS_COMPUTER'),
    },
    {
      value: Devices.WINDOWS_COMPUTER,
      label: t('participants.enums.devices.WINDOWS_COMPUTER'),
    },
    {
      value: Devices.LINUX_COMPUTER,
      label: t('participants.enums.devices.LINUX_COMPUTER'),
    },
  ];
};
